import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { PrimaryButton } from '../ui/PrimaryButton';
import { scrollToId } from '../../utils/scroll';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-187" data-mp="2szonn9goyq7r">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-188" data-mp="2sywpbqvpmeds">
        <SectionTag icon="✓" data-id="element-189" data-mp="2o13mn7tm82i9">Lo que recibes</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-190" data-mp="2o1wnjs5w7xsh">
          12 Tomos Listos
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-191" data-mp="2ea0ly74llpji">De 1.º Primaria a 2.º Bachillerato</p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-192" data-mp="29cqoc47227kl">
        {volumes.map((volume, i) => <m.div key={volume.title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-navy/10 bg-cream p-6" data-id="element-193" data-mp="25c6ogsv3kpur" data-mpi={i}>
            <span className="text-3xl" aria-hidden="true" data-id="element-194" data-mp="2u5hg1pc3cvk2">
              {volume.emoji}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-navy" data-id="element-195" data-mp="2y5rqbe6x284q">{volume.title}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-196" data-mp="3lx6rv4qvclex">{volume.text}</p>
          </m.div>)}
      </div>

      <div className="mt-8 flex justify-center" data-id="element-197" data-mp="3qt4bbjxfi7vx">
        <PrimaryButton onClick={() => scrollToId('oferta')} data-id="element-198" data-mp="3cw8numgfkdwc">Quiero los 12 tomos</PrimaryButton>
      </div>
    </section>;
}